import { isUiException, uiExceptions } from './uiExceptions';
export const getCorrectVariant = (type, variant) => {
    if (isUiException(type, variant)) {
        const correctVariant = uiExceptions[variant];
        if (process.env.NODE_ENV === 'development' || process.env.NODE_ENV === 'test') {
            console.warn(`DEPRECATION WARNING: Icon variant "${variant}" is deprecated. Please use "${correctVariant}".`);
        }
        return correctVariant;
    }
    return variant;
};
